import * as React from "react";
import { Box } from "@mui/material";
import { StaticImage } from "gatsby-plugin-image";
import type { EventImageMap } from "../../../data/events/types";

const HERO_ALT =
  "Avioboglietto in Bianco: cena in bianco gourmet sulla pista illuminata del Monferrato";
const SECTION_ALT =
  "Cena in bianco all'Aviosuperficie Boglietto, esperienza esclusiva nel Monferrato";

export const avioboglietoInBiancoImages: EventImageMap = {
  Card: ({ eager }: { eager?: boolean }) => (
    <StaticImage
      src="../../../images/events/white-dinner-2025/cena-in-bianco-esperienza-esclusiva-nel-monferrato.jpg"
      alt={HERO_ALT}
      placeholder="blurred"
          quality={72}
      layout="fullWidth"
      aspectRatio={16 / 9}
      transformOptions={{ cropFocus: "center" }}
      loading={eager ? "eager" : "lazy"}
    />
  ),
  Hero: () => (
    <>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <StaticImage
          src="../../../images/events/white-dinner-2025/cena-in-bianco-esperienza-esclusiva-nel-monferrato.jpg"
          alt={HERO_ALT}
          placeholder="blurred"
          quality={72}
          layout="fullWidth"
          aspectRatio={64 / 27}
          transformOptions={{ cropFocus: "center" }}
        />
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <StaticImage
          src="../../../images/events/white-dinner-2025/cena-in-bianco-esperienza-esclusiva-nel-monferrato.jpg"
          alt={HERO_ALT}
          placeholder="blurred"
          quality={72}
          layout="fullWidth"
          aspectRatio={4 / 3}
          transformOptions={{ cropFocus: "center" }}
        />
      </Box>
    </>
  ),
  WhenWhere: () => (
    <>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <StaticImage
          src="../../../images/events/white-dinner-2025/cena-in-bianco-evento-esclusivo-nel-monferrato.jpg"
          alt={SECTION_ALT}
          placeholder="blurred"
          quality={72}
          layout="fullWidth"
          aspectRatio={8 / 3}
          transformOptions={{ fit: "cover", cropFocus: "center" }}
          style={{ height: "100%" }}
        />
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <StaticImage
          src="../../../images/events/white-dinner-2025/cena-in-bianco-evento-esclusivo-nel-monferrato.jpg"
          alt={SECTION_ALT}
          placeholder="blurred"
          quality={72}
          layout="fullWidth"
          aspectRatio={16 / 9}
          transformOptions={{ fit: "cover", cropFocus: "center" }}
          style={{ height: "100%" }}
        />
      </Box>
    </>
  ),
  ScheduleSide: () => (
    <StaticImage
      src="../../../images/events/white-dinner-2025/cena-in-bianco-avioboglietto-monferrato-buon-cibo.jpg"
      alt={SECTION_ALT}
      placeholder="blurred"
          quality={72}
      layout="fullWidth"
      aspectRatio={4 / 3}
      transformOptions={{ cropFocus: "center" }}
      style={{ height: "100%" }}
    />
  ),
};
